import { render, staticRenderFns } from "./SMSVerify.vue?vue&type=template&id=713fd032&"
import script from "./SMSVerify.vue?vue&type=script&lang=js&"
export * from "./SMSVerify.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports